export default "//static.tradera.net/touchweb/static/output/images/mao-feature-modal-active-1x.abd4acfb.png";